<template>
    <div name="complete" class="complete">
        <div class="header" @click="goHome">← 홈화면으로 돌아가기</div>
        <div class="wrapper" v-if="showcase === 'seoulone'">
            <div class="area">
                <img style="width: 100%;" src="../../assets/showcase/complete_seoulone.png" />
                <!-- <span class="text"><span style="font-weight: 700;">가입이 완료되었어요!</span><br>이제 안내된 순서에 따라<br>건강 측정을 시작해볼까요?</span>
                <span class="text2">건강 측정을 완료하시면<br>건강 측정 결과가 입력하신 휴대전화의<br>카카오톡으로 발송됩니다.</span>
                <span class="text3">*4번 체성분 분석기(인바디) 검사 시<br>인바디 기기에 동일한 휴대전화 번호를 입력해주세요.</span> -->
            </div>
        </div>
        <div class="wrapper2" v-else>
            <div class="area">
                <img style="width: 100%;" src="../../assets/showcase/complete.png" />
                <!-- <span class="text"><span style="font-weight: 700;">가입이 완료되었어요!</span><br>이제 안내된 순서에 따라<br>건강 측정을 시작해볼까요?</span>
                <span class="text2">건강 측정을 완료하시면<br>건강 측정 결과가 입력하신 휴대전화의<br>카카오톡으로 발송됩니다.</span>
                <span class="text3">*4번 체성분 분석기(인바디) 검사 시<br>인바디 기기에 동일한 휴대전화 번호를 입력해주세요.</span> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'complete',
    computed: {
     showcase() {
            return this.$route.params.showcase
        }
    },
    methods: {
        goHome: function()
        {
            this.$emit('goHome')
        },
        reset: function()
        {
          this.$emit('resetCount')
        }
    }
}
</script>

<style scoped>

    .complete {
        width: 100%;
        height: 100vh;
        overflow: hidden;    
    }
    .header {
        height: 9vh;
        width: 100%;
        font-size: 2vh;
        color: var(--xi-dark-blue, #000);
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -1.12px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 5%;
        box-sizing: border-box;
        background: var(--theme-sub1);
    }
    .wrapper {
        padding: 0 5vw 6.2vh 5vw;
        width: 100%;
        height: calc(100vh - 9vh);
        box-sizing: border-box;
        overflow: hidden;
    }
    .wrapper2{
        padding: 6.2vh 5vw 6.2vh 5vw;
        width: 100%;
        height: 100vh;
        box-sizing: border-box;
        overflow: hidden;
    }
    .area {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
    }
    .text {
        font-size: 6.1vw;
        color: var(--xi-dark-blue, #173C55);
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: 131.818%;
        letter-spacing: -2.64px;
    }
    .text2{
        font-size: 3.2vw;
        color: var(--xi-dark-blue, #173C55);
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: 133.333%;
        letter-spacing: -2.64px;
        margin-top: 3.1vh;
    }
    .text3 {
        color: var(--xi-blue, #8BB9D7);
        text-align: center;
        font-family: Pretendard;
        font-size: 3.2vw;
        font-style: normal;
        font-weight: 500;
        line-height: 133.333%;
        letter-spacing: -1.44px;
        margin-top: 3.1vh;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Complete.vue